import React from 'react'
import './Task.css'
import {  AiOutlineCloseCircle} from 'react-icons/ai';

export default function Task({id, text, completed, taskCompleted, taskDeleted, taskEdited}) {

    return (
        <div className={completed ? "task-conteiner-completed" : "task-conteiner" }>
            <div className='task-text'
                onClick={() => taskCompleted(id)} >
                {text}
            </div> 
            <div className='task-container-icon'
            onClick={()=> taskDeleted(id)} >
                <AiOutlineCloseCircle className="task-icon" />
            </div>
        </div>
    );
}
